/**
 * PageHeader — barra que fica entre o Topbar e o conteudo da pagina.
 *
 * Estrutura padrao das diretrizes ERP: Breadcrumb + titulo da pagina (com
 * subtitulo opcional) + slot de acoes primarias a direita. Paginas que ja
 * tem seus proprios `EntityHeader` podem nao usar PageHeader — coexiste sem
 * conflito.
 *
 * Props:
 *   - title: string obrigatoria
 *   - subtitle: string opcional
 *   - crumbs: opcional — sobrescreve o breadcrumb auto-derivado
 *   - actions: ReactNode opcional — botoes/menus a direita
 *   - sticky: boolean — se true, gruda no topo abaixo do Topbar (default true)
 */
import React from "react";

import Breadcrumb from "../Breadcrumb";

import {
  Actions,
  Container,
  HeaderRow,
  Subtitle,
  Title,
  TitleStack,
} from "./styles";

export default function PageHeader({
  title,
  subtitle,
  crumbs,
  actions,
  sticky = true,
  hideCrumb = false,
}) {
  return (
    <Container $sticky={sticky}>
      {!hideCrumb && <Breadcrumb crumbs={crumbs} />}
      <HeaderRow>
        <TitleStack>
          {title && <Title>{title}</Title>}
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </TitleStack>
        {actions && <Actions>{actions}</Actions>}
      </HeaderRow>
    </Container>
  );
}
